const HEDGING_AMOUNT_RESERVED_ID = 22;

export const isHedgingAmountId = currentId => currentId === HEDGING_AMOUNT_RESERVED_ID;
